import React, { useEffect, useRef, useState } from 'react'
import api from '../../../api';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Toast } from 'primereact/toast';


const MeasureSocial_3 = () => {
      const userID = sessionStorage.getItem("UserID");
      const currentDate1 = new Date();
      const toast = useRef(null);

      const formattedCurrentDate = `${currentDate1.getDate().toString().padStart(2, '0')}-${(currentDate1.getMonth() + 1).toString().padStart(2, '0')}-${currentDate1.getFullYear()} ${currentDate1.getHours().toString().padStart(2, '0')}:${currentDate1.getMinutes().toString().padStart(2, '0')}:${currentDate1.getSeconds().toString().padStart(2, '0')}`;
      const dt = useRef(null);
      const [loading, setLoading] = useState(false);
  
      const [data, setData] = useState([]);
      const getDemographicRawData = async () => {
        try {
          setLoading(true);

          const requestData = {
            logged_in_userid: userID,
            table_name:"trn_tbl_baseline_osss",
            synceddatetime: formattedCurrentDate,
            FormCode: "202",
            ApiKey: "kavin",
            AppTypeNo: "3",
            AppVersion: "1.0.0",
            data_source: "W"
          };
    
        const result = await api.get_Raw_Data(requestData);
        const responseData = result.trn_tbl_baseline_osss;
        const slNo = responseData.map((item, index) => ({
                   ...item, slno: index + 1
               }));
               setData(slNo);
        } catch (error) {
          console.error("Error fetching state:", error);
          toast.current.show({
            severity: "info",
            summary: "No Data Found",
            detail: "There is no data for this table"
          });
        } finally {
          setLoading(false);
        }
      };
    
      useEffect(() => {
        getDemographicRawData();
      }, []);

      const cleanValue = (value) => {
        if (value === "-999" || value === -999) return "";

        if (typeof value === "string" && value.includes("$")) {
          return value.split("$").join(",");
        }

        return value;
      };


    const exportData = data.map(item => ({
        "SlNo": item.slno,
        "Sate" : cleanValue(item.fld_state_name),
        "District" : cleanValue(item.fld_district_name),
        "Site" : cleanValue(item.fld_site_name),
        "Taluk" : cleanValue(item.fld_taluk_name),
        "Village" : cleanValue(item.fld_village_name),
        "PHC" : cleanValue(item.fld_phc_name),
        "PHC Type" : cleanValue(item.fld_phc_type_name),
        "PRS name" : cleanValue(item.fld_prs_name),
        // "Participant registration date" : cleanValue(item.fld_participant_registration_date),
        "Participant Name" : cleanValue(item.fld_participant_name),
        "Participant ID" : cleanValue(item.fld_participant_id),
        "OSSS done date": cleanValue(item.fld_osss_done_date),
        "How many people are so close to you that you can count on them if you have great personal problems?": cleanValue(item.fld_how_many_people_are_close_to_you_name),
        "How much interest and concern do people show in what you do?": cleanValue(item.fld_how_much_interest_and_concern_people_name),
        "How easy is it to get practical help from neighbors if you should need it?":cleanValue(item.fld_how_easy_get_practical_help_from_neighbors_name),
        "Total score":cleanValue(item.fld_osss_total_score),
        "Loggedin User ID": cleanValue(item.fld_loggedin_user_id),
        "System Inserted Date": item.fld_system_inserted_datetime
          ? new Date(item.fld_system_inserted_datetime).toISOString().split("T")[0]
          : "", // fallback in case value is missing
    }));

      const handleDownloadCSV = () => {
          if (!data || data.length === 0) {
            console.warn("No data available to export");
            return;
          }

          // Convert JSON to worksheet
          const worksheet = XLSX.utils.json_to_sheet(exportData);

          // Create a new workbook and append the worksheet
          const workbook = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(workbook, worksheet, `Measure_of_Social_support_Data`);

          // Generate buffer
          const excelBuffer = XLSX.write(workbook, {
            bookType: "csv",
            type: "array"
          });

          // Create Blob and trigger download
          const dataBlob = new Blob([excelBuffer], { type: "text/csv;charset=utf-8;" });
          saveAs(dataBlob, "Measure_of_Social_support_Data.csv");
        };


  return (
    <div>
        <Toast ref={toast} position="top-right" />

        {loading && (
            <div className="backdrop">
                <ProgressSpinner style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }} />
            </div>
        )}
        <span className='flex justify-content-end mt-2 mb-4'>
            <Button className="downloadbutton"
                label='Download CSV'
                icon="pi pi-download"
                onClick={handleDownloadCSV}
            />
        </span>
            <DataTable
              value={data}
              scrollHeight="350px"
              paginator
              rows={10}
              rowsPerPageOptions={[5, 10, 25, 50]}
              ref={dt}
              scrollable
            >
              <Column field="slno" header="Sl.No" />
              <Column field="fld_phc_name" header="PHC Name" />
              <Column field="fld_loggedin_user_id" header="User ID" />
              <Column field="fld_participant_name" header="Participent Name"></Column>
              <Column field="fld_participant_id" header="Participent ID"></Column>
              <Column field="fld_osss_done_date" header="OSSS done date"></Column>
              <Column field="fld_how_many_people_are_close_to_you_name" header="Q 1"></Column>
              <Column field="fld_how_much_interest_and_concern_people_name" header="Q 2"></Column>
              <Column field="fld_how_easy_get_practical_help_from_neighbors_name" header="Q 3"></Column>
              <Column field="fld_osss_total_score" header="Total Score"></Column>
            </DataTable>
    </div>
  )
}

export default MeasureSocial_3